import FormSelectField from "./FormSelectField";
import React from "react";
import {SelectProps} from "@mui/material/Select/Select";
import {FormikProps} from "formik";
import {TFunction} from "i18next";
import MenuItem from "@mui/material/MenuItem";
import {get} from "lodash";
import {Grid} from "@mui/material";
import {GridTypeMap} from "@mui/material/Grid/Grid";

export type SelectOptions = {
    value: string | boolean | number;
    label: string;
};
export type GenericSelectProps = SelectProps & {
    fieldName: string;
    label: string;
    form: FormikProps<any>;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    selectOptions: SelectOptions[];
    t: TFunction;
};

const GenericSelect = ({
    fieldName,
    label,
    form,
    t,
    selectOptions,
    isGridItem = false,
    gridProps = {xs: 6},
    ...rest
}: GenericSelectProps) => {
    const getSelect = () => (
        <>
            <FormSelectField
                fieldName={fieldName}
                form={form}
                label={label}
                labelId={`label-${fieldName}`}
                value={get(form?.values, fieldName)}
                onChange={(e) => {
                    if (e.target.value) {
                        const {value: id} = selectOptions.find(({value}) => `${value}` === `${e.target.value}`) ?? {
                            value: undefined,
                        };
                        form.setFieldValue(fieldName, id);
                    }
                }}
                {...rest}
            >
                {selectOptions.map((select, index) => {
                    return (
                        <MenuItem value={`${select.value}`} key={`${fieldName}_opt_${index}`}>
                            {select.label}
                        </MenuItem>
                    );
                })}
            </FormSelectField>
        </>
    );
    return isGridItem ? (
        <Grid item {...gridProps}>
            {getSelect()}
        </Grid>
    ) : (
        getSelect()
    );
};
export default GenericSelect;
